










import Vue from 'vue'
import {Howl, Howler} from 'howler'
import { isPC, isPad } from '@plat-components/utils2/_esm5/detector'
import logger from '@plat-components/utils2/_esm5/logger'

import { mp3Link } from '@/constant'

const sharecfg = {
  title: 'bilibili2020年度动画榜单',
  desc: '你喜欢的作品和角色上榜了吗？',
  link: location.origin + location.pathname,
  pics: 'https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/-hmNpk~ze.jpg',
  show: [ 'bili', 'weibo', 'qq', 'qzone', 'baidu_tieba', 'wechat' ], // 选填项，单独显示选择的分享途径
}

let soundInstence: any = {}

export default Vue.extend({
  data() {
    return {
      isPC,
      isPad,
      soundRuning: 0
    }
  },
  methods: {
    soundAction() {
      if (this.soundRuning) {
        soundInstence.pause()
      } else {
        soundInstence.play()
      }
      // console.log(soundInstence)
    },
    iconStop() {
      // @ts-ignore
      this.$refs.music.style.animationPlayState = 'paused'
      this.soundRuning = 0
    },
    iconRun() {
      // @ts-ignore
      this.$refs.music.style.animationPlayState = 'running'
      this.soundRuning = 1
    }
  },
  mounted() {
    if (isPC) {
      import('@bilibili/share-pc').then(({ default: billiShare }) => {
        // console.info('pc', billiShare)
        billiShare.share(sharecfg, this.$refs.ref1, (to: string) => {
          // console.log(type);
          logger('shareto', { to })
          const hashReg = location.hash.match(/scene(\w+)/)
          const index = hashReg && hashReg[1] || 0
          logger('shareAtPage' + index)
        },)
      })
    }
    if (isPad) {
      import('@bilibili/share-h5-next').then(mod => {
        console.info('h5', mod)
      })
    }

    soundInstence = new Howl({
      src: [mp3Link],
      autoplay: true,
      loop: true,
      volume: 0.5,
      onend: function() {
        // console.log('Finished!');
      }
    });

    soundInstence.on('play', () => {
      // console.log('sound play')
      this.soundRuning = 1
      this.iconRun()
    });

    soundInstence.on('pause', () => {
      // console.log('sound pause')
      this.soundRuning = 0
      this.iconStop()
    });

    // soundInstence.on('load', () => {
    //   console.log('sound load')
    // });

    // soundInstence.once('stop', () => {
    //   console.log('sound stop')
    // });
  },
})
